import { Spin } from 'antd';
import React from 'react';

// layout needs to be imported as first component
// otherwise css order breaks
// https://github.com/gatsbyjs/gatsby/issues/9733#issuecomment-490132623
import PastoralVisitLayout from '../components/Layout/PastoralVisitLayout';
import PastoralVisitNotActive from '../components/PastoralVisit/PastoralVisitNotActive';
import PastoralVisitContent from '../components/PastoralVisit/PastoralVisitContent';
import { useIsPastoralVisitActiveAndAvailable } from '../hooks/pastoralVisit/useIsPastoralVisitActiveAndAvailable';
import { useFetchAccountOptions } from '../api/actions/useFetchAccountOptions';

const PastoralVisit = () => {
  const isPastoralVisitActive = useIsPastoralVisitActiveAndAvailable();
  const isFetchingAccountOptions = useFetchAccountOptions();

  let content = null;
  if (isFetchingAccountOptions) {
    content = <Spin />;
  } else if (isPastoralVisitActive) {
    content = <PastoralVisitContent />;
  } else {
    content = <PastoralVisitNotActive />;
  }

  return <PastoralVisitLayout>{content}</PastoralVisitLayout>;
};

export default PastoralVisit;
